import {
    createRegisterableComponentWithData,
    CurationAndCurationMetadataLoader,
} from '@news-mono/web-common'
import React from 'react'
import { DevelopingNews } from './DevelopingNews'

export const DevelopingNewsRegistration = createRegisterableComponentWithData(
    'developing-news',
    CurationAndCurationMetadataLoader,
    (props: {}, data, services) => {
        if (
            data.loaded &&
            data.result.articles.length > 0 &&
            data.result.metadata['developing-news-headline']
        ) {
            return (
                <DevelopingNews
                    items={data.loaded && data.result.articles}
                    headLine={data.result.metadata['developing-news-headline']}
                    themeOverrideType={
                        data.result.metadata['developing-news-theme']
                    }
                    onEvent={services.onEvent}
                />
            )
        }
        return null
    },
)
